import {
  emitSharedEvent,
  type ObservationRunPollPayload,
  SHARED_EVENTS,
} from '@frontend-platform/host-state';

/**
 * Remote → host signal that starts aistudio's calibration polling banner.
 *
 * The banner is the host's: `client/components/PollingBanner.vue`, mounted
 * globally by aistudio's Scaffold, which polls
 * `GET /resources/observation-run/event-status?event=OBSERVATION_RUN` and then
 * switches to MQTT. aistudio's own Calibration views start it by emitting
 * `APP_EVENTS.OBSERVATION_RUN` on its internal `appBus`; a federated remote has
 * no access to that bus.
 *
 * Travels over `@frontend-platform/host-state`'s event channel rather than a raw `window`
 * CustomEvent: the module is a Module Federation singleton (`eager` on the
 * host, and remotes bundle no fallback copy — their manifest lists empty
 * `assets` for it), so host and remote execute the same module instance and the
 * channel is a real shared bus. That buys a typed payload and a shared event
 * name over a stringly-typed global, and keeps all host↔remote plumbing in one
 * place.
 *
 * Note the distinction from `setSharedState`: that mirrors host *state* one way
 * (host writes, remotes read). This is a one-shot *command* travelling the
 * other way, which is why it is an event and not a state key.
 *
 * Handled by aistudio's `client/views/Calibration/FederatedView.vue`, which
 * forwards it onto `appBus`. No-ops safely in standalone dev, where nothing is
 * subscribed.
 */
export function notifyHostObservationRunPoll(payload: ObservationRunPollPayload): void {
  emitSharedEvent(SHARED_EVENTS.OBSERVATION_RUN_POLL, payload);
}

export type { ObservationRunPollPayload };
